module.exports = __webpack_public_path__ + "media/icons/player1-1ed2b0f5.png";